export default [
  'setValidations',
  'setValue',
  'resetValue',
  'getValue',
  'hasValue',
  'getErrorMessage',
  'getErrorMessages',
  'isFormDisabled',
  'isValid',
  'isPristine',
  'isFormSubmitted',
  'isRequired',
  'showRequired',
  'showError',
  'isValidValue',
  'submitted',
  'validationError',
  'validationErrors'
];



// WEBPACK FOOTER //
// ./webpack/components/Elements/FormsyProps.js